// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3uBKQ","footer":"Form_footer__22edw"};